import { useAppStore } from '@store'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Ruta /planner/newDesign.
 *
 * TEMPORAL (solicitud del usuario): no mostrar el modal Sí/No.
 * Se ejecuta automáticamente la opción "No" — nuevo diseño en blanco sin guardar.
 * Para restaurar el modal, descomentar el Dialog al final de este archivo.
 */
export function NewDesign() {
  const navigate = useNavigate()
  const resetStore = useAppStore.use.resetStore()
  const closeModal = useAppStore.use.closeModal()
  const unselect = useAppStore((s) => s.unselectAll)
  const setMode = useAppStore.use.setMode()

  useEffect(() => {
    // Equivalente a pulsar "No" en el modal de confirmación.
    resetStore()
    setTimeout(() => {
      unselect()
    }, 100)
    closeModal()
    navigate('/planner')
    setMode('MODE_IDLE')
  }, [resetStore, unselect, closeModal, navigate, setMode])

  return null
}

/* TEMPORAL (solicitud del usuario): modal de confirmación oculto.
   Restaurar importando Dialog y reemplazando NewDesign por esta versión:

import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function NewDesign() {
  const navigate = useNavigate()
  const t = useAppStore.use.t()
  const resetStore = useAppStore.use.resetStore()
  const closeModal = useAppStore.use.closeModal()
  const unselect = useAppStore((s) => s.unselectAll)
  const openModal = useAppStore.use.openModal()
  const setMode = useAppStore.use.setMode()

  useEffect(() => {
    openModal()
    return () => {
      closeModal()
    }
  }, [])

  function handleClickYes() {
    localStorage.setItem('pendingAction', 'newDesignAfterSave')
    localStorage.setItem('pendingFrom', 'newDesign')
    sessionStorage.setItem('pendingSave', 'true')
    closeModal()
    navigate('/planner/saveProject')
  }

  function handleClickNo() {
    resetStore()
    setTimeout(() => {
      unselect()
    }, 100)
    closeModal()
    navigate('/planner')
    setMode('MODE_IDLE')
  }

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className='fixed inset-0 z-20 bg-black opacity-30' />
        <Dialog.Content className='dialog border-colorAtemporal text-md absolute left-1/2 top-1/2 z-50 -mt-3 h-min w-72 -translate-x-1/2 -translate-y-1/2 border-[1px] bg-C/Color1 p-2 text-left'>
          <Dialog.Title className='sr-only'>{'Dialog Title'}</Dialog.Title>
          <Dialog.Description className='sr-only'>{'Dialog Description'}</Dialog.Description>
          <div className='flex flex-col items-center justify-center gap-y-1.5'>
            <p className='mt-2 text-center font-normal'>{'¿Quieres guardar el proyecto antes de crear uno nuevo?'} </p>
            <div className='button container mb-2 mt-2 flex w-full justify-center gap-3'>
              <button id='yes' onClick={handleClickYes} className='bg-colorAtemporal flex cursor-pointer items-center rounded-xl px-4 text-sm font-normal text-C/Color1'>
                {'Sí'}
              </button>
              <button id='no' onClick={handleClickNo} className='flex cursor-pointer items-center rounded-xl border border-C/Color3 bg-C/Color7 px-4 py-0.5 text-sm font-normal text-C/Color3'>
                {'No'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
*/
